/*
 * Purpose: Canonical domain SSOT — preview host, legacy redirects, API origins
 * Last modified: 2026-07-10 | Agent
 * Completeness: 100
 */

/** Live product app — primary custom domain on Render / Pages */
export const CANONICAL_APP_HOST = 'preview.autoblocks.run' as const;
export const CANONICAL_APP_URL = `https://${CANONICAL_APP_HOST}` as const;

/** Legacy apex hosts → 301 to preview (Render redirect service or Cloudflare rules) */
export const LEGACY_APP_HOSTS = ['autoblocks.run', 'www.autoblocks.run'] as const;

/** Legacy marketing host → 301 to preview */
export const LEGACY_MARKETING_HOST = 'autoblocks.pro' as const;
export const LEGACY_MARKETING_URL = `https://${LEGACY_MARKETING_HOST}` as const;

/** API — unchanged; cookies use COOKIE_DOMAIN=.autoblocks.run */
export const CANONICAL_API_HOST = 'api.autoblocks.run' as const;
export const CANONICAL_API_URL = `https://${CANONICAL_API_HOST}` as const;

export const COOKIE_DOMAIN = '.autoblocks.run' as const;

/** Hosts where /api is rewritten to the backend (same-origin fetch). */
export const SAME_ORIGIN_API_HOSTS = new Set<string>([
  CANONICAL_APP_HOST,
  ...LEGACY_APP_HOSTS,
  'autoblocks-run.onrender.com',
  'localhost',
  '127.0.0.1',
]);

/** Default CORS + OAuth return origins (comma-separated for env). */
export const DEFAULT_CORS_ORIGINS = [
  CANONICAL_APP_URL,
  ...LEGACY_APP_HOSTS.map((h) => `https://${h}`),
  'https://autoblocks-run.onrender.com',
  'https://autoblocks-run.pages.dev',
  'http://localhost:3000',
  'http://127.0.0.1:3000',
] as const;

export function isAutoblocksAppHost(hostname: string): boolean {
  const h = hostname.toLowerCase();
  if (h === CANONICAL_APP_HOST) return true;
  return (LEGACY_APP_HOSTS as readonly string[]).includes(h);
}

export function githubOAuthCallbackUrl(appUrl: string = CANONICAL_APP_URL): string {
  return `${appUrl.replace(/\/$/, '')}/api/auth/github/callback`;
}
